import { render, staticRenderFns } from "./AddTutorData.vue?vue&type=template&id=78dc8eba&scoped=true"
import script from "./AddTutorData.vue?vue&type=script&lang=js"
export * from "./AddTutorData.vue?vue&type=script&lang=js"
import style0 from "./AddTutorData.vue?vue&type=style&index=0&id=78dc8eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc8eba",
  null
  
)

export default component.exports